// Open/close toggle only — dragging is Swiper's job on desktop (see
// entriesSwiperHandler.js) and mobile is a plain stacked list.
class EntrySliderHandler {
  constructor(root = document) {
    this.entries = Array.from(root.querySelectorAll(".entries-slider__entry"))

    this.entries.forEach(entry => {
      const btn = entry.querySelector("button")
      if (!btn) return
      btn.addEventListener("click", ev => {
        entry.classList.toggle("entries-slider__entry--open")
        btn.innerHTML = entry.classList.contains("entries-slider__entry--open") ? "Lukke" : "Åpne";
      })
    })
  }
}

export default EntrySliderHandler
